(function($) {

  function cssPropertyValueSupported(prop, value) {
    var d = document.createElement('div');
    d.style[prop] = value;
    return d.style[prop] === value;
  }

  // if (cssPropertyValueSupported('position', 'sticky')) {
  //   $('#sticky-nav').css({
  //     'position': 'sticky',
  //     'top': 0,
  //     'z-index': 9999,
  //   });
  // }
  // else {  
  var $body = $('body');
  var $header = $('.site-header');
  var $stickyNav = $('#sticky-nav');
  var navOffset =  ($body.hasClass('admin-bar') && window.innerWidth > 600) ? $stickyNav.offset().top - 32 : $stickyNav.offset().top;
  var navHeight = $stickyNav.height();
  var top = ($body.hasClass('admin-bar') && window.innerWidth > 600) ? 32 : 0;
  // var cutoff;

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
  }

  function throttle(callback, limit) {
    var wait = false;
    return function() {
        if (wait) {
            return;
        }
        callback.call();
        wait = true;
        setTimeout(function() {
            wait = false;
        }, limit);
    };
  }

  function setNavOffset() {
    top = ($body.hasClass('admin-bar') && window.innerWidth > 600) ? 32 : 0;
    navOffset = ($body.hasClass('admin-bar') && window.innerWidth > 600) ? $stickyNav.offset().top - 32 : $stickyNav.offset().top;
  }


  function toggleFixed() {
    var currentScroll = $(window).scrollTop();

    if (currentScroll > navOffset) {
      $header.css({
        'padding-bottom': navHeight
      });
      $stickyNav.css({
        'position': 'fixed',
        'top': top,
        'z-index': 9999,
        'width': '100%'
      });
      $stickyNav.addClass('stuck');  
    } else {
      $header.removeAttr('style');
      $stickyNav.removeAttr('style');
      $stickyNav.removeClass('stuck');  
    }
  }

  setNavOffset();
  
  // $(window).on('scroll', toggleFixed);
  $(window).on('scroll', debounce(toggleFixed, 10));
  // $(window).resize(debounce(setNavOffset, 150));

})(jQuery);